import React from "react"


function Over18(){
    return (
        <>
        <h2>Over 18 page</h2>
        </>
    )
}

export default Over18;